import AnomaliesTabs from "./AnomaliesTabs";

const Anomalies = () => {
  return (
    <>
      <AnomaliesTabs />
    </>
  );
};

export default Anomalies;
